import React from "react";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ThemeDefaultComponent from "../../components/ThemeDefaultComponent/ThemeDefaultComponent";
import { useAuthStore } from "../../stores/authStore";
import LoginForm from "./components/LoginForm";
import LoginPageLayout from "./components/LoginPageLayout";
import useLoginForm from "./hooks/useLoginForm";

const LoginPage = () => {
    const isLoading = useAuthStore((s) => s.isLoading);
    const loginForm = useLoginForm();

    return (
        <ThemeDefaultComponent>
            <LoginPageLayout>
                <LoginForm {...loginForm} />
            </LoginPageLayout>
            <LoadingOverlay open={isLoading} />
        </ThemeDefaultComponent>
    );
};

export default LoginPage;
